const sizes = {
  xxs: 3,
  xs: 6,
  s: 9,
  m: 13,
  0: 0,
}

export default sizes
